module.exports = __webpack_public_path__ + "static/media/C02.56917f14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/customs/C02.png
// module id = 202
// module chunks = 0